<template lang="pug">
.login-page-container.flex-mid
  login(
    :env="env"
    placeholder="请输入手机号"
    @login="login"
  )
</template>

<script>
import config from '@/const/config';
import { Login } from '@hb/h5-components';
import { UserUtils } from '../../utils/user';

export default {
  components: {
    Login,
  },
  data() {
    return {
      env: config.env === 'dev' ? 'fat' : config.env,
    };
  },
  methods: {
    login(v) {
      const { from } = this.$route.query;
      if (v && v.token) {
        UserUtils.setUserInfo(v);
        if (from) {
          this.$router.replace({
            path: from,
            query: {
              token: v.token,
              needRefresh: '1',
            },
          });
        } else {
          this.$router.go(-1);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.login-page-container {
  background-image: url(https://m.hellobike.com/resource/LivingH5/LivingH5/kEJNj6bhzmx-Mps-vNkok.png);
  background-size: 100%;
  background-color: #effafe;
  background-repeat: no-repeat;
  padding-top: 1.2rem;
  height: 100vh;
}
</style>
